import { z } from 'zod'
import { AddressSchema } from './address'

/**
 * Dónde VIVE una persona: la dirección, más si esa vivienda está a su nombre.
 *
 * Es un schema aparte de `AddressSchema` a propósito, no una extensión de conveniencia. Una
 * dirección la tienen también el representante legal y el domicilio fiscal de la empresa, y la
 * pregunta por la titularidad no significa lo mismo en ninguno de los dos. Si viviera en
 * `AddressSchema`, el guardarraíl de diccionario ↔ Zod (`portal-registry-zod-sync.spec.ts`)
 * exigiría un descriptor para cada consumidor, y el asesor terminaría revisando campos que
 * nadie llena.
 *
 * LOS DOS VAN JUNTOS. `isInOwnName === false` obliga a `ownershipJustification`: es cumplimiento,
 * no cosmética — la IVE quiere saber por qué el domicilio declarado es de un tercero, y un «no»
 * sin explicación no dice nada. La regla no puede vivir acá porque depende de OTRO campo del
 * mismo objeto; está en el `superRefine` de `IndividualApplicant.forLevel`, junto a la de
 * `otherProfession`, que es el mismo patrón.
 *
 * Los dos son opcionales en la forma para no trabar el auto-guardado del portal: la residencia ya
 * es obligatoria desde el nivel `partial`, así que un campo suyo requerido en la forma se exigiría
 * antes de que el cliente llegue a la pregunta.
 */
export const ResidenceSchema = AddressSchema.extend({
  isInOwnName: z.boolean().optional(),
  // `.nullish()` pelado y NO el primitivo `optionalString()`, que es lo mismo más un
  // `.transform(null -> undefined)`. Ese transform lo vuelve un ZodEffects y el generador del
  // OpenAPI no lo atraviesa: emitía `ownershipJustification: string | null` SIN el `?`, o sea una
  // clave OBLIGATORIA en el contrato que leen la app móvil y terceros. Los hermanos que usan el
  // primitivo (`otherProfession`, `economicActivityRTU`) sí salen opcionales, pero por otro
  // motivo: viven en la raíz, y ahí el envoltorio progresivo les pone el `.optional()` encima.
  ownershipJustification: z.string().nullish()
})

export type Residence = z.infer<typeof ResidenceSchema>
